import { normalizeTags } from "../../articles/tags.js";
const STOP_WORDS = new Set(["a", "an", "and", "as", "at", "by", "for", "from", "in", "is", "of", "on", "or", "the", "to", "with"]);

function plainText(value) {
  return String(value || "").replace(/<[^>]*>/g, " ").replace(/&nbsp;/g, " ").replace(/\s+/g, " ").trim();
}

function truncateAtWord(value, limit) {
  const text = plainText(value);
  if (text.length <= limit) return text;
  const sliced = text.slice(0, limit + 1);
  return `${sliced.slice(0, Math.max(0, sliced.lastIndexOf(" "))).trim()}…`;
}

export function generateSeoTitle(article) {
  return truncateAtWord(article?.title, 60);
}

export function generateMetaDescription(article) {
  const source = plainText(article?.subtitle) || plainText(article?.content);
  return truncateAtWord(source, 155);
}

export function generateArticleSlug(title) {
  const words = plainText(title).toLowerCase().normalize("NFKD").replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9\s-]/g, " ").split(/\s+/).filter(Boolean);
  const meaningful = words.filter((word) => !STOP_WORDS.has(word));
  const selected = (meaningful.length >= 3 ? meaningful : words).slice(0, 8);
  return selected.join("-").replace(/-+/g, "-").replace(/^-|-$/g, "");
}

export function generateSocialMetadata({ article, seoTitle, metaDescription }) {
  return {
    title: seoTitle || generateSeoTitle(article),
    description: metaDescription || generateMetaDescription(article),
    image: article?.image || null
  };
}

export function detectPrimaryTopic(article) {
  const tags = normalizeTags(article?.tags);
  return tags[0] || article?.category?.name || article?.category || null;
}

export function generateSeoDefaults(article, existingState = {}) {
  const now = new Date();
  const seoTitle = existingState.seoTitleMode === "MANUAL" && article?.seoTitle ? article.seoTitle : generateSeoTitle(article);
  const metaDescription = existingState.metaDescriptionMode === "MANUAL" && article?.seoDescription ? article.seoDescription : generateMetaDescription(article);
  const slug = existingState.slugMode === "MANUAL" && article?.slug ? article.slug : generateArticleSlug(article?.title);
  const socialMetadata = existingState.socialMetadataMode === "MANUAL" && existingState.socialMetadata
    ? existingState.socialMetadata
    : generateSocialMetadata({ article, seoTitle, metaDescription });
  return { seoTitle, metaDescription, slug, socialMetadata, primaryTopic: detectPrimaryTopic(article), generatedAt: now };
}
